import { validateNotEmptyString } from '@vy/utils';
import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useXeroConnect() {
  return useMutation(async (credentials: { clientId: string; clientSecret: string; environment: 'sandbox' | 'production' }) => {
    const api = getPrivateApi();

    const { redirectUrl } = await api.xeroAuthConnect({
      xeroAuthConnectRequest: credentials,
    });

    validateNotEmptyString(redirectUrl, 'redirectUrl');

    window.location.href = redirectUrl;
  });
}
